import useTranslate from "@app/_hooks/useTranslate";
import { Button } from "@ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@ui/dialog";
import { XIcon } from "lucide-react";
import { usePathname } from "next/navigation";
import { PropsWithChildren, useState } from "react";
import ForgottenPasswordForm from "./ForgottenPasswordForm";
import SignInForm from "./SignInForm";

export default function DesktopSignIn({ children }: PropsWithChildren) {
  const t = useTranslate();
  const pathname = usePathname();
  const [authDialog, setAuthDialog] = useState(false);
  const [prevPathname, setPrevPathname] = useState(pathname);
  const [resetPasswordDialog, setResetPasswordDialog] = useState(false);

  if (prevPathname !== pathname) {
    setPrevPathname(pathname);
    setAuthDialog(false);
    setResetPasswordDialog(false);
  }

  return (
    <Dialog open={authDialog} onOpenChange={setAuthDialog}>
      {children}
      <DialogContent className="max-w-md p-6">
        <DialogClose className="absolute top-0 right-0 p-4">
          <XIcon className="size-4" />
          <span className="sr-only">{t("close")}</span>
        </DialogClose>
        <SignInForm
          callback={() => setAuthDialog(false)}
          header={DialogTitle}
          description={DialogDescription}
        >
          <Dialog
            open={resetPasswordDialog}
            onOpenChange={setResetPasswordDialog}
          >
            <Button
              type="button"
              variant="link"
              className="w-full"
              onClick={() => setResetPasswordDialog(true)}
            >
              {t("forgotPassword")}
            </Button>
            <DialogContent className="p-8">
              <DialogClose className="absolute top-0 right-0 p-4">
                <XIcon className="size-4" />
                <span className="sr-only">{t("close")}</span>
              </DialogClose>
              <ForgottenPasswordForm
                callback={() => setResetPasswordDialog(false)}
                header={DialogTitle}
                description={DialogDescription}
              />
            </DialogContent>
          </Dialog>
        </SignInForm>
      </DialogContent>
    </Dialog>
  );
}
